export default __webpack_public_path__ + "static/media/1428.49d87982.png";